import {call, put, takeLatest} from 'redux-saga/effects'
import activeJsonApi from '../../json-api'
import {defineTypes} from '../../helpers'
import {reduxFetch} from '../../http/reduxFetch'
import ReservationEndpoint from '../../persistence/ReservationEndpoint'
import {push} from 'react-router-redux'
import Alert from 'react-s-alert';

const reservationIndexTypes = {...defineTypes('RESERVATION_INDEX_TYPES')}
const reservationStore = new activeJsonApi('reservations')

export const initialState = {
  reservations: {},
  started: false,
  loading: false,
  loaded: false
}

export const actions = {
  deleteReservation(id) {
    return {type: 'DELETE_RESERVATION', reservation_id_to_delete: id}
  },
  getReservations() {
    return {type: reservationIndexTypes.REQUEST}
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case reservationIndexTypes.REQUEST:
      return {...state, started: true, loading: true}
    case reservationIndexTypes.FAILURE:
      return {...state, loading: false, error: action.error}
    case reservationIndexTypes.SUCCESS:
      return {...state, order: action.order, loaded: true, loading: false, started: false}
    case 'DELETE_RESERVATION':
      return {...state, reservation_id_to_delete: action.reservation_id_to_delete}
    default:
      return state
  }
}

export const selectors = {
  loaded: ({reservationIndex}) => {
    return reservationIndex['loaded']
  },
  reservations_store: () => {
    return reservationStore.store.getState()
  },
  reservations: () => {
    return reservationStore.getAll('orders')
  },
  customer: (reservation) => {
    let id = reservation['relationships']['customer'] &&
      reservation['relationships']['customer']['data'] &&
      reservation['relationships']['customer']['data']['id']
    return reservationStore.getObject('customers', id)
  }
}

export function* reservationsIndexSaga() {
  try {
    const reservations = yield call(reduxFetch, ReservationEndpoint.index(1))
    console.log(reservations)
    reservationStore.reset()
    reservationStore.updateStore(reservations)
    yield put({type: reservationIndexTypes.SUCCESS})
  } catch (error) {
    yield put({type: reservationIndexTypes.FAILURE, error})
  }
}

export function* deleteReservationSaga(action) {
  console.log(action)
  try {
    const response = yield call(reduxFetch, ReservationEndpoint.deleteReservation(action.reservation_id_to_delete))
    if (response['data']) {
      yield put({type: reservationIndexTypes.SUCCESS})
      yield put({type: reservationIndexTypes.REQUEST})
      yield call(Alert.success, '<div>Reservation Destroyed!</div>')
      yield put(push({pathname: '/reservations'}))
    } else {
      yield put({type: reservationIndexTypes.FAILURE, errors: response['errors']})
    }
  } catch (error) {
    console.log(error)
    yield put({type: reservationIndexTypes.FAILURE, errors: error})
  }
}

export function* rootSaga() {
  yield takeLatest(reservationIndexTypes.REQUEST, reservationsIndexSaga)
  yield takeLatest('DELETE_RESERVATION', deleteReservationSaga)
}





// WEBPACK FOOTER //
// ./src/sagas/reservation/index.js